import { useContext } from "react"
import { AuthContext } from "./auth-user"
import { UserContext } from "./online-user"
import { PaymentContext } from "./payment-user"

export const useAuth = () => useContext(AuthContext)
export const useUser = () => useContext(UserContext)
export const usePayment = () => useContext(PaymentContext)
